import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ImagePreview, MegaPopUp } from "../components";
import analytics from "../utils/analytics";

const PageContextState = React.createContext(undefined);

const PageContextFunction = React.createContext(undefined);

const PageContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [city, setCity] = useState("");
  const [typeContent, setTypeContent] = useState("");
  const [pageMode, setPageMode] = useState("banner");
  const [contentMode, setContentMode] = useState("mobile");

  const [openPopup, setOpenPopUp] = useState({
    state: false,
    data: {},
    currentCity: "",
    typePopUp: "",
  });
  const [idInView, setIdInView] = useState(null);

  const [isLive, setIsLive] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const [isRegist, setIsRegist] = useState(false);
  const [registrationUrl, setRegistrationUrl] = useState("");

  const [activeColor, setActiveColor] = useState("#fff");

  const [imagePreview, setImagePreview] = React.useState("");
  const [imagePreviewModal, setImagePreviewModal] = React.useState(false);

  const redirectWhenStillOnTeaserMode = useCallback(() => {
    if (pageMode === "teaser" && city === "blitar") return navigate("/blitar");
  }, [pageMode, city]);

  useEffect(() => {
    analytics.init();
  }, []);

  return (
    <PageContextState.Provider
      value={{
        city,
        pageMode,
        openPopup,
        idInView,
        contentMode,
        activeColor,
        imagePreview,
        imagePreviewModal,
        isLive,
        videoUrl,
        isRegist,
        registrationUrl,
      }}
    >
      <PageContextFunction.Provider
        value={{
          setCity,
          setPageMode,
          setOpenPopUp,
          redirectWhenStillOnTeaserMode,
          setIdInView,
          setContentMode,
          setActiveColor,
          setImagePreview,
          setImagePreviewModal,
          setIsLive,
          setVideoUrl,
          setIsRegist,
          setRegistrationUrl,
        }}
      >
        {children}
        <MegaPopUp />
        {imagePreviewModal && (
          <ImagePreview
            closeButton={() => setImagePreviewModal(false)}
            imgFile={imagePreview}
          />
        )}
      </PageContextFunction.Provider>
    </PageContextState.Provider>
  );
};

export default PageContextProvider;

export const usePageContextState = () => {
  const ctx = useContext(PageContextState);

  if (!ctx) {
    throw new Error("PageContextState out of boundary");
  }

  return ctx;
};

export const usePageContextFunction = () => {
  const ctx = useContext(PageContextFunction);

  if (!ctx) {
    throw new Error("PageContextFunction out of boundary");
  }

  return ctx;
};
